import React from 'react'
import { NavLink } from 'react-router-dom'
// CSS
import '../assets/css/categories-nav.css'

export default function CategoriesNav(props) {
  return (
    <div className='categories_nav'>
      <div className='categories_container'>
        <div className='categories select_n'>
          <ul className='categories_list'>
            <li><NavLink to='/'><span className='fas fa-home'></span> Home</NavLink></li>
            <li><NavLink to='/products'><span className='fas fa-th'></span> Categories</NavLink>
              <div className='side_drop'>
                {
                  props.categories.map((category, index) => {
                    return (
                      <ul key={index}>
                        <div className='title'>{category.name}</div>
                        {
                          category.subCategories.map((subCategory, index) => {
                            return (
                              <li><NavLink to={subCategory.link} key={index}>{subCategory.name}</NavLink></li>
                            )
                          })
                        }
                      </ul>
                    )
                  })
                }
              </div>
            </li>
            <li><NavLink to='/products'><span className='fas fa-shopping-cart'></span> Products</NavLink></li>
            <li><NavLink to='/my-account'><span className='fas fa-user'></span> My Account</NavLink></li>
            <li><NavLink to='/blogs'><span className='fab fa-blogger'></span> Blogs</NavLink></li>
          </ul>
        </div>
      </div>
    </div>
  )
}
